import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    FruitfulCustomIcon,
    H2Emphasized,
    type StackProps,
    View,
    XStack,
    YStack,
} from 'smoothie';

interface CustomizeIconProps extends StackProps {
    icon: string;
    color: string;
}

const CustomizeIcon = ({ icon, color, ...viewProps }: CustomizeIconProps) => {
    return (
        <XStack position="absolute" {...viewProps}>
            <FruitfulCustomIcon
                icon={icon}
                color={color}
                size="xl"
                showShadow
            />
        </XStack>
    );
};
const Customize = ({ onPressContinue }: { onPressContinue: () => void }) => {
    return (
        <YStack
            flex={1}
            $sm={{
                width: '100%',
                maxWidth: 1100,
                alignSelf: 'center',
            }}
            justifyContent="space-between"
        >
            <XStack flex={1} justifyContent="center">
                <CustomizeIcon
                    color="red"
                    icon="globe"
                    top={14}
                    left={10}
                    rotate="-10deg"
                />
                <CustomizeIcon
                    icon="diamond"
                    color="orange"
                    top={32}
                    right={14}
                    rotate="10deg"
                />
                <CustomizeIcon icon="bankNote" color="green" bottom={100} />
                <View alignSelf="flex-end" width="65%">
                    <H2Emphasized textAlign="center">
                        Let&apos;s customize your account
                    </H2Emphasized>
                </View>
            </XStack>
            <XStack flex={1} justifyContent="center">
                <CustomizeIcon
                    icon="wallet"
                    color="blue"
                    top={16}
                    right={-8}
                    rotate="10deg"
                />
                <CustomizeIcon
                    icon="home"
                    color="purple"
                    top={16}
                    left={-8}
                    rotate="-6deg"
                />
                <CustomizeIcon
                    icon="gamingPad"
                    color="peach"
                    bottom={90}
                    right={140}
                    rotate="-6deg"
                />
            </XStack>
            <View
                marginHorizontal={16}
                $sm={{
                    position: 'relative',
                    bottom: '40%',
                    width: 700,
                    alignSelf: 'center',
                }}
                marginBottom={24}
            >
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Continue"
                    onPress={onPressContinue}
                />
            </View>
        </YStack>
    );
};

export default Customize;
